import type { EventStatusEnum } from "../../types";

import React from "react";
import { useTranslation } from "react-i18next";

import EventStatusBadge from "../../pages/myEventsPage/components/eventStatusBadge";
import { getStatusContent } from "../modals/eventStatus/statusContent";

interface EventStatusControlsProps {
  status: EventStatusEnum;
  eventId: number;
}

export default function EventStatusControls({
  status,
  eventId,
}: EventStatusControlsProps) {
  const { t } = useTranslation();

  return (
    <>
      <p className="fs-6 fw-bold text-info mb-2">
        {t("events.detail.eventStatus")}
      </p>
      <EventStatusBadge status={status} className="mb-2" />
      {getStatusContent(status, eventId)}
    </>
  );
}
